import React, { useEffect, useState } from 'react';
import { GlassCard } from './GlassCard';
import { GlassInput } from './GlassInput';
import { GlassButton } from './GlassButton';
import { X } from 'lucide-react';
import { Goal } from '../hooks/useGoals';
interface CreateGoalModalProps {
  onClose: () => void;
  onSubmit: (goal: {
    name: string;
    type: 'debt' | 'savings';
    targetAmount: number;
    startDate: string;
    endDate: string;
  }) => void;
  editGoal?: Goal;
}
export function CreateGoalModal({
  onClose,
  onSubmit,
  editGoal
}: CreateGoalModalProps) {
  const [name, setName] = useState('');
  const [type, setType] = useState<'debt' | 'savings'>('savings');
  const [targetAmount, setTargetAmount] = useState('');
  const [endDate, setEndDate] = useState('');
  useEffect(() => {
    if (editGoal) {
      setName(editGoal.name);
      setType(editGoal.type);
      setTargetAmount(editGoal.targetAmount.toString());
      setEndDate(editGoal.endDate);
    }
  }, [editGoal]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({
      name,
      type,
      targetAmount: parseFloat(targetAmount),
      startDate: editGoal?.startDate || new Date().toISOString().split('T')[0],
      endDate
    });
    onClose();
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm" data-id="element-14">
      <GlassCard className="w-full max-w-md p-6" data-id="element-15">
        <div className="flex items-center justify-between mb-6" data-id="element-16">
          <h2 className="text-2xl font-bold text-white" data-id="element-17">
            {editGoal ? 'Edit Goal' : 'Create New Goal'}
          </h2>
          <button onClick={onClose} className="text-white/70 hover:text-white transition-colors" data-id="element-18">
            <X size={24} data-id="element-19" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-20">
          <GlassInput label="Goal Name" placeholder="Emergency Fund" value={name} onChange={setName} required data-id="element-21" />

          <div className="space-y-2" data-id="element-22">
            <label className="block text-sm font-medium text-white/90" data-id="element-23">
              Goal Type
            </label>
            <div className="flex gap-3" data-id="element-24">
              <button type="button" onClick={() => setType('savings')} className={`flex-1 py-3 rounded-2xl backdrop-blur-xl border transition-all ${type === 'savings' ? 'bg-gradient-to-r from-green-400/40 to-blue-400/40 border-white/40 text-white' : 'bg-white/10 border-white/20 text-white/70'}`} data-id="element-25">
                💰 Savings
              </button>
              <button type="button" onClick={() => setType('debt')} className={`flex-1 py-3 rounded-2xl backdrop-blur-xl border transition-all ${type === 'debt' ? 'bg-gradient-to-r from-orange-400/40 to-red-400/40 border-white/40 text-white' : 'bg-white/10 border-white/20 text-white/70'}`} data-id="element-26">
                💳 Debt
              </button>
            </div>
          </div>

          <GlassInput label="Target Amount" type="number" placeholder="5000" value={targetAmount} onChange={setTargetAmount} required min={1} step={0.01} data-id="element-27" />

          <GlassInput label="Target Date" type="date" value={endDate} onChange={setEndDate} required data-id="element-28" />

          <div className="flex gap-3 pt-4" data-id="element-29">
            <GlassButton type="button" variant="secondary" onClick={onClose} className="flex-1" data-id="element-30">
              Cancel
            </GlassButton>
            <GlassButton type="submit" variant="primary" className="flex-1" data-id="element-31">
              {editGoal ? 'Save Changes' : 'Create Goal'}
            </GlassButton>
          </div>
        </form>
      </GlassCard>
    </div>;
}